module.exports = __webpack_public_path__ + "assets/img/btn-back-fd270ecf.png";